/**
 *
 * LanguageChipInput
 *
 */

import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { FormattedMessage, useIntl } from 'react-intl';
import languageCodeNames from '~/languageCodeNames.json';
import messages from './messages';

type Language = {
  key: string;
  de: string;
  en: string;
  es: string;
  fr: string;
  it: string;
  ru: string;
  uk: string;
};

type LanguageChipInputProps = {
  onChange: (selectedLanguages: readonly Language[]) => void;
  languageCodes?: Language[];
  selectedLanguages: string[];
  label?: React.ReactNode;
  meta?: {
    touched?: boolean;
    error?: React.ReactNode;
  };
};

const defaultLanguageCodes = Object.entries(languageCodeNames).map(
  ([key, value]) => ({
    key,
    ...value,
  })
);

export const LanguageChipInput = ({
  languageCodes = defaultLanguageCodes,
  label = <FormattedMessage {...messages.languages} />,
  ...props
}: LanguageChipInputProps) => {
  const intl = useIntl();
  return (
    <Autocomplete
      multiple
      id="tags-outlined"
      options={languageCodes}
      getOptionLabel={(option) => option[intl.locale as 'de']}
      defaultValue={languageCodes.filter((language) =>
        props.selectedLanguages.some((lang) => lang === language.key)
      )}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          error={Boolean(props.meta?.touched && props.meta?.error)}
          helperText={props.meta?.touched && props.meta?.error}
        />
      )}
      onChange={(_event, value) => {
        props.onChange(value);
      }}
    />
  );
};

export default LanguageChipInput;
